import ApiMethods from "../../ApiManager/ApiMethods";

/*
  Shared cache + in-flight-request dedup for GET client-packages/packages — the same
  assignable-packages list ClientPackageDialog and PackageAssignFlow each fetch on open.
  Both of those are freshly mounted every time they're opened (Members/index.js renders them
  conditionally, e.g. `{packageAssignTarget && <PackageAssignFlow open .../>}`), so each open is
  a real mount, not just a prop toggle — which means React 18 StrictMode's dev-only "run effects
  twice on mount" behavior fires this fetch twice, back to back, every single time either dialog
  is opened. Mirrors the exact fix membersStore.js already uses for GET client (see
  `ensureMembersLoaded`'s `inFlightPromise`): callers share one in-flight promise instead of each
  firing their own request, so two near-simultaneous callers — whether that's StrictMode's
  double-mount or both dialogs happening to load at once — collapse into a single network call.
*/

const STALE_TIME_MS = 60 * 1000;

let cachedPackages = null;
let cachedAt = 0;
let inFlightPromise = null;

export function getAssignablePackages({ force = false } = {}) {
  const isStale = Date.now() - cachedAt > STALE_TIME_MS;
  if (!force && cachedPackages && !isStale) {
    return Promise.resolve(cachedPackages);
  }
  if (inFlightPromise) return inFlightPromise;
  inFlightPromise = ApiMethods.get("client-packages/packages")
    .then((res) => {
      cachedPackages = res || [];
      cachedAt = Date.now();
      return cachedPackages;
    })
    .finally(() => {
      inFlightPromise = null;
    });
  return inFlightPromise;
}

// The Admin App's package setup rarely changes mid-session, but this is here (unused for now)
// so a future "packages changed" action can force a fresh fetch instead of waiting out the TTL —
// mirrors membersStore.js's invalidateMembersCache.
export function invalidateAssignablePackagesCache() {
  cachedAt = 0;
}
